import { useDispatch } from 'react-redux';
import { signIn } from 'features/authSlice';
import { getTokenFromResponse, identifyFullStoryUser, setCrispUser } from 'utils/helpers';
import { saveAccessToken } from 'utils/localStorage';
import { useCallback } from 'react';
import { getRequest } from 'utils/api';

const useLoginUser = () => {
  const dispatch = useDispatch();

  return useCallback(
    response => {
      const token = getTokenFromResponse(response);

      if (token) {
        saveAccessToken(token);
      }

      getRequest({ endpoint: 'users/current' })
        .then(user => {
          dispatch(signIn(user));
          setCrispUser(user);
          identifyFullStoryUser(user);
        })
        .catch(() => {});
    },
    [dispatch]
  );
};

export default useLoginUser;
